import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./fonts.css";
import "./index.css";
import "./css/embla.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import UMobileHero from "./components/UMobileHero";
import Carousel from "./components/CarouselCard-NOTINUSE";
import About from "./pages/about";
import Onboard from "./pages/onboard";
import { EmblaCarousel } from "./components/EmblaCarousel";
import { EmblaOptionsType } from "embla-carousel";
//import APIDocumentation from "./pages/api-docs";
//import Register from "./pages/register";
//import Login from "./pages/login";

function App() {
  return (

    <Router>
      <div className="min-h-screen flex flex-col">
        {/* Navbar at the top */}
        <Navbar />

        {/* Main Content */}
        <main className="flex-grow bg-gray-100">
          <Routes>
            {/* Homepage route - displays UMobileHero and FeaturedCarousel */}
            <Route
              path="/"
              element={
                <>
                  <UMobileHero />
                  
                  <EmblaCarousel
                   slides={[
                    {
                      imagesrc: "./images/SimSwap.png",
                      title: "SIM Swap API",
                      description: "Verify users by detecting recent SIM swaps to prevent fraud.",
                      buttonHref: "https://developers.opgw.u.com.my",
                    },
                    {
                      imagesrc: "./images/NumVerify.jpg",
                      title: "Number Verification API",
                      description: "Ensure the accuracy of users' phone numbers for secure communication.",
                      buttonHref: "https://developers.opgw.u.com.my",
                    },
                    {
                      imagesrc: "./images/DeviceLocation.jpg",
                      title: "Device Location",
                      description: "Create, retrieve and delete event subscriptions to realize geofencing for a user device.",
                      buttonHref: "https://developers.opgw.u.com.my",
                    },
                    {
                      imagesrc: "./images/QOD.jpg",
                      title: "Quality on Demand",
                      description: "Allows the discovery of Quality of Service (QoS) profiles and its characteristics.",
                      buttonHref: "https://developers.opgw.u.com.my",
                    },
                    {
                      imagesrc: "./images/DeviceStatus.jpg",
                      title: "Device Status",
                      description: "Allows the ability to subscribe to Reachability status events.",
                      buttonHref: "https://developers.opgw.u.com.my",
                    },
                    {
                      imagesrc: "./images/TrafficInfluence.jpg",
                      title: "Traffic Influence",
                      description: "Provides the capability to establish the optimal routing",
                      buttonHref: "https://developers.opgw.u.com.my",
                    },
                  ]}
                  buttonText="Explore"
                  />
                  ;
                </>
              }
            />

            {/* About page route */}
            <Route path="/about" element={<About />} />

            {/* API Documentation page route */}

            {/** Onboard page route */}
            <Route path="/onboard" element={<Onboard />} />

            {/* Register and Login page routes */}
          </Routes>
        </main>

        {/* Footer at the bottom */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
